import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  selectedFocusLayer: null,
  selectedGradientView: 'population',
  selectedPopulationViewMode: 'nation'
}

const focusLayerSlice = createSlice({
  name: 'focusLayer',
  initialState,
  reducers: {
    setSelectedFocusLayer: (state, action) => {
      state.selectedFocusLayer = action.payload
    },
    clearFocusLayer: (state) => {
      state.selectedFocusLayer = null
    },
    setSelectedGradientView: (state, action) => {
      state.selectedGradientView = action.payload
    },
    setSelectedPopulationViewMode: (state, action) => {
      state.selectedPopulationViewMode = action.payload
    }
  }
})

export const {setSelectedFocusLayer, clearFocusLayer, setSelectedGradientView, setSelectedPopulationViewMode} =
  focusLayerSlice.actions

// Selectors
export const selectSelectedFocusLayer = (state) => state.focusLayer.selectedFocusLayer
export const selectSelectedGradientView = (state) => state.focusLayer.selectedGradientView
export const selectSelectedPopulationViewMode = (state) => state.focusLayer.selectedPopulationViewMode
export default focusLayerSlice.reducer
